import { render, staticRenderFns } from "./giveaway-landing.vue?vue&type=template&id=ed0ff070&scoped=true"
import script from "./giveaway-landing.vue?vue&type=script&lang=js"
export * from "./giveaway-landing.vue?vue&type=script&lang=js"
import style0 from "./giveaway-landing.vue?vue&type=style&index=0&id=ed0ff070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0ff070",
  null
  
)

export default component.exports